const getStorageValue = (key, defaultValue) => {
    return JSON.parse(localStorage.getItem('nyamnyam_' + key)) || defaultValue;
};

const updateStorageValue = (key, value) => {
    localStorage.setItem('nyamnyam_' + key, JSON.stringify(value));
};

export { getStorageValue, updateStorageValue };
